import React, { useEffect, useState } from "react";
import AdminUserService from "../../../services/adminUserServices";
// import ConfigurationHeader from "../../../components/configuration/ConfigurationHeader";

interface HelpVideo {
  ID: number;
  Title: string;
  Section: string | null;
  Description: string | null;
  MaterialLink: string;
  DisplayOrder: number;
  Status: number; // 1 = Active, 0 = Inactive
}

const HelpVideos: React.FC = () => {

  const [helpVideos, setHelpVideos] = useState<HelpVideo[]>([]);
  const [Id, setId] = useState<number>(0);

  const getHelpVideos = async () => {
    try {
      const response = await AdminUserService.getHelpVideos();
      if (response.data?.data) {
        const sortedVideos = response.data.data.sort(
          (a: HelpVideo, b: HelpVideo) => a.DisplayOrder - b.DisplayOrder
        );
        setHelpVideos(sortedVideos);
      } else {
        alert(response.data.errors?.[0] || "Failed to load help videos.");
      }
    } catch (error) {
      console.error("Error fetching help videos:", error);
      alert("An error occurred while fetching help videos.");
    }
  };
  useEffect(() => {
    getHelpVideos();
  }, []);

  return (
    <div className="help-videos">
      <h2>Help Videos</h2>
      {/* <ConfigurationHeader /> */}
      
      <div className="table-responsive">
        <table className="help-videos-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Section</th>
              <th>Description</th>
              <th>Material Link</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
          {helpVideos.map((video, index) => (
              <tr key={video.ID}>
                <td>{index + 1}</td>
                <td>{video.Title}</td>
                <td>{video.Section || "-"}</td>
                <td>{video.Description || "-"}</td>
                <td>
                  <a
                    href={video.MaterialLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="watch-link"
                  >
                    Watch
                  </a>
                </td>
                <td>{video.Status === 1 ? "Active" : "Inactive"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>
        {`
          .help-videos {
            padding: 20px;
          }
          .help-videos h2 {
            margin-top: 0.8rem;
            margin-bottom: -0.5rem;
            font-family: "Inter", sans-serif;
            font-size: 1.3rem;
            font-weight: 400;
            color: var(--secondary-color);
            text-align: left;
          }
          .help-videos-table {
            // width: 100%;
            // border-collapse: collapse;
            margin-top: 20px;
            font-family: Arial, Helvetica, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }
          .help-videos-table th,
          .help-videos-table td {
            border: 1px solid #ddd;
            padding: 10px;
            text-align: left;
          }
          .help-videos-table th {
            // background-color: #f4f4f4;
            background-color: #04aa6d;
            color: white;
            font-weight: 600;
          }
          .help-videos-table tr:nth-child(even) {
            background-color: #f2f2f2;
          }
          .help-videos-table tr:hover {
            background-color: #ddd;
          }
          .watch-link {
            color: #1890ff;
            text-decoration: none;
          }
          .watch-link:hover {
            text-decoration: underline;
          }
        `}
      </style>
    </div>
  );
};

export default HelpVideos;